// extracted by mini-css-extract-plugin
module.exports = {"icon":"shape-menu-icon_icon__5R70G","iconContent":"shape-menu-icon_iconContent__NnJgH","skeleton":"shape-menu-icon_skeleton__E2JBY"};